import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgbActiveModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { NgbDateITParserFormatter } from '@hm_app/@core/utils/ngb-date-it-parser-formatter';
import { dateToNgbDateStruct } from '@hm_app/@core/models/dateStr';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import * as moment from 'moment';

export function toDateParser(date: Date, index: number) {
    return date ? moment(date).format('L') : null;
}

@Component({
    selector: 'aggiungi-risultati',
    templateUrl: './inserisci-data-alert.component.html',
    styleUrls: ['./inserisci-data-alert.component.scss'],
    providers: [
        { provide: NgbDateParserFormatter, useClass: NgbDateITParserFormatter },
    ],
})
export class InserisciDataAlertComponent implements OnInit {
    form = new FormGroup({});
    model = {
        date: null
    };
    fields: FormlyFieldConfig[] = [];



    modalHeader: string;
    modalBody: string;

    minDate: NgbDateStruct;
    maxDate: NgbDateStruct;

    protected _date: NgbDateStruct;

    set date(d: NgbDateStruct) {
        this._date = d;
    }

    get date(): NgbDateStruct {
        return this._date;
    }

    @Input()
    set current_date(d: Date) {
        if (d) {
            this.date = dateToNgbDateStruct(d);
        } else {
            this.date = dateToNgbDateStruct(new Date());
        }
        this.model.date = this.date;
    }


    @Output() action = new EventEmitter<NgbDateStruct>();

    constructor(protected activeModal: NgbActiveModal) { }

    ngOnInit() {
        // this.date = this.date;
        this.fields = [
            {
                key: 'date',
                type: 'datepicker',
                templateOptions: {
                    templateOptions: {
                        minDate: this.minDate,
                        maxDate: this.maxDate
                    }
                }
            },
        ];
    }

    closeModal(d: NgbDateStruct) {
        this.action.emit(d);
        this.close();
    }

    close() {
        this.activeModal.close();
    }

}
